// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Siq","top":"styles_top__2WpYN","left":"styles_left__dw-_E","description":"styles_description__1TIP3"};